import { useLocalStorage } from 'usehooks-ts';

import { isIOS } from '@growtherapy/analytics';

import { AccessibilitySettingsTab } from './AccessibilitySettingsTab';
import { STORED_ACCESSIBILITY_SETTINGS_KEY } from './constants';

export function AccessibilitySettingsTabWrapper() {
  const [accessibilitySettings, setAccessibilitySettings] = useLocalStorage(STORED_ACCESSIBILITY_SETTINGS_KEY, {
    disableNotificationTimeouts: false,
  });

  return (
    <AccessibilitySettingsTab
      onChange={setAccessibilitySettings}
      accessibilitySettings={accessibilitySettings}
      showLiveCaptioningHelp={!isIOS(navigator.userAgent)}
    />
  );
}
